import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../../theme/ThemeContext';
import './TopNav.scss';

const navItems = [
  { path: '/', label: 'Home' },
  { path: '/modules', label: 'Modules' },
  { path: '/pricing', label: 'Pricing' },
  { path: '/ai-studio', label: 'AI Studio' },
  { path: '/about', label: 'About' },
  { path: '/contact', label: 'Contact' },
];

interface TopNavProps {
  setMobileMenuOpen: (open: boolean) => void;
  isMobile?: boolean;
}

export const TopNav: React.FC<TopNavProps> = ({ setMobileMenuOpen }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header className="top-nav">
      <div className="top-nav-left">
        <button 
          className="hamburger-btn"
          onClick={() => setMobileMenuOpen(true)}
          aria-label="Open menu"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
        
        <a href="#/" className="logo">
          <span className="logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="16 18 22 12 16 6"/>
              <polyline points="8 6 2 12 8 18"/>
            </svg>
          </span>
          <span className="logo-text">FLVR SOFT</span>
        </a>
      </div>

      <div className="top-nav-center">
        <nav className="nav-pills">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={(isActive: boolean) => `nav-pill ${isActive ? 'active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="top-nav-right">
        <button 
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="5"/>
              <line x1="12" y1="1" x2="12" y2="3"/>
              <line x1="12" y1="21" x2="12" y2="23"/>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
              <line x1="1" y1="12" x2="3" y2="12"/>
              <line x1="21" y1="12" x2="23" y2="12"/>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          )}
        </button>
      </div>
    </header>
  );
};
